export enum UserStatusId {
  Created = 1,
  Submitted = 2,
  Pending = 3,
  Approved = 4,
  Verified = 5,
  Attested = 6,
  Queried = 7,
  Rejected = 8,
  Draft = 9,
  InProgress = 10,
  Completed = 11,
  PendingPayment = 12,
  Closed = 13,
  Printed = 14,
}

export interface ApiUserStatus {
  id?: number;
  name?: string;
}

export interface ApiUser {
  id: number;
  uid?: string;
  userNo?: string;
  username: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  genderId: number;
  dateOfBirth?: string;
  nationalIdNumber?: string;
  email: string;
  primaryPhone?: string;
  secondaryPhone?: string;
  roleId: number;
  isActive: boolean;
  isConfirmed?: boolean;
  isSystemAdmin?: boolean;
  isClientAdmin?: boolean;
  isUserOnly?: boolean;
  profileImagePath?: string;
  signaturePath?: string;
  signatureExists?: boolean;
  status?: ApiUserStatus;
  statusId?: number;
  statusName?: string;
  workflowId?: number;
}

export interface CreateUserDto {
  userNo: string;
  username: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  genderId: number;
  dateOfBirth?: string;
  nationalIdNumber?: string;
  email: string;
  primaryPhone?: string;
  secondaryPhone?: string;
  password?: string;
  roleId: number;
  workflowId?: number;
  isActive: boolean;
  isConfirmed: boolean;
  isSystemAdmin: boolean;
  isClientAdmin: boolean;
  isUserOnly: boolean;
  profileImagePath?: string;
  signaturePath?: string;
}

export interface UpdateUserDto {
  id?: number;
  uid?: string;
  userNo?: string;
  username?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  genderId?: number;
  dateOfBirth?: string;
  nationalIdNumber?: string;
  email?: string;
  primaryPhone?: string;
  secondaryPhone?: string;
  password?: string;
  roleId?: number;
  workflowId?: number;
  isActive?: boolean;
  isConfirmed?: boolean;
  isSystemAdmin?: boolean;
  isClientAdmin?: boolean;
  isUserOnly?: boolean;
  profileImagePath?: string;
  signaturePath?: string;
}
